module.exports = __webpack_public_path__ + "img/moniterstu2.c3bf271f.jpeg";